import { Link } from "react-router-dom";
import {
  Search, Filter, ClipboardCheck, GraduationCap, FileText, Send, Stamp,
  Wallet, Home as HomeIcon, ArrowRight, Handshake, Users, Megaphone, Building2,
} from "lucide-react";
import { Button } from "../components/ui/button";
import { PageHero, Reveal, SectionHeading } from "../components/common";
import { SERVICES, SERVICE_PILLARS } from "../mock";

const ICONS = { Search, Filter, ClipboardCheck, GraduationCap, FileText, Send, StampIcon: Stamp, Wallet, Home: HomeIcon };
const PILLAR_ICONS = { Handshake, Users, Megaphone, Building2 };

export default function Services() {
  return (
    <>
      <PageHero
        eyebrow="Our Services"
        title="End-to-end support, every step of the way"
        subtitle="From your first research session to landing on campus, GDIH Elite handles it all — so you can focus on your future."
        image="https://images.unsplash.com/photo-1523240795612-9a054b0db644"
      />

      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHeading
            eyebrow="Education Group"
            title="A pioneer in the education industry"
            subtitle="GDIH Elite has been associated with renowned universities, institutes and schools across Australia, UK, USA, Canada, Singapore, Malaysia, China and Indonesia — establishing offshore campuses and marketing, branding and promoting institutions in India and overseas."
          />
          <div className="grid sm:grid-cols-2 gap-6 mt-14">
            {SERVICE_PILLARS.map((p, i) => {
              const Icon = PILLAR_ICONS[p.icon] || Handshake;
              return (
                <Reveal key={p.title} delay={i * 60}>
                  <div className="group h-full bg-[#f7faf8] rounded-2xl p-8 border border-transparent hover:border-[#c9a227]/40 hover:bg-white hover-lift">
                    <div className="w-14 h-14 rounded-xl bg-[#004030] grid place-items-center text-[#e0c05a] group-hover:bg-[#c9a227] group-hover:text-[#013d2b] transition-colors">
                      <Icon size={26} />
                    </div>
                    <h3 className="font-display text-xl font-bold text-[#012a1e] mt-5">{p.title}</h3>
                    <p className="text-slate-500 mt-2.5 leading-relaxed text-[15px]">{p.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section-pad bg-[#f4f8f6] pt-0">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHeading
            eyebrow="For Students"
            title="Your journey, handled end to end"
            subtitle="Nine expert-led steps that carry you from first idea to landing on campus."
          />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.icon] || Search;
              return (
                <Reveal key={s.no} delay={i * 50}>
                  <div className="group h-full bg-white rounded-2xl p-7 border border-transparent hover:border-[#c9a227]/40 hover-lift">
                    <div className="flex items-center justify-between">
                      <div className="w-14 h-14 rounded-xl bg-[#004030] grid place-items-center text-[#e0c05a] group-hover:bg-[#c9a227] group-hover:text-[#013d2b] transition-colors">
                        <Icon size={26} />
                      </div>
                      <span className="font-display text-4xl font-bold text-[#004030]/10">{s.no}</span>
                    </div>
                    <h3 className="font-display text-xl font-bold text-[#012a1e] mt-5">{s.title}</h3>
                    <p className="text-slate-500 mt-2.5 leading-relaxed text-[15px]">{s.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <div className="mt-16 bg-[#004030] rounded-3xl p-10 md:p-14 text-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-80 h-80 bg-[#c9a227]/10 rounded-full blur-3xl" />
            <div className="relative">
              <SectionHeading light eyebrow="Get Started" title="Not sure where to begin?" subtitle="Book a free consultation and our experts will map your entire journey — no cost, no obligation." />
              <Link to="/contact"><Button className="mt-8 bg-[#c9a227] hover:bg-[#e0c05a] text-[#013d2b] rounded-full h-12 px-8 font-bold">Book a Free Consult <ArrowRight size={17} className="ml-1" /></Button></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}